export enum WarehouseType {
  MiniWarehouse = 'mini_warehouse',
  MobileWarehouse = 'mobile_warehouse',
  Courier = 'courier',
  Cleaner = 'contractor',
}

export const allWarehouseTypes: WarehouseType[] = [
  WarehouseType.MiniWarehouse,
  WarehouseType.MobileWarehouse,
  WarehouseType.Courier,
  WarehouseType.Cleaner,
]

export type Warehouse = {
  id: number
  name: string
  type: WarehouseType
}
